/* eslint-disable no-undef */
import NiceSelect from "nice-select2";
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function () {
  console.log('campsite');

  function niceSelect() {
    let select = document.getElementById('campsite-region');

    if (select) {
      const options = {
        searchable: true,
        placeholder: 'Region',
        searchtext: 'Välj',
      };

      new NiceSelect(select, options);
    } else {
      console.warn('No element found with ID');
    }
  }

  niceSelect();

  let map = null;
  let geocoder = null;
  let markers = [];
  let regionPolygon = null;
  let swedenRegionsGeojson = null; // Store loaded GeoJSON

  // Default Centered Region
  const DEFAULT_LAT = 60.128161;
  const DEFAULT_LNG = 18.643501;
  const DEFAULT_ZOOM = 4;

  // Load Swedish regions GeoJSON
  fetch('/wp-content/themes/rightprice/assets/data/swedish_regions.geojson')
    .then(response => response.json())
    .then(data => {
      swedenRegionsGeojson = data;
      // console.log('Loaded Swedish regions GeoJSON:', data.features.length, 'regions');
      regionRedirect(); // Ensure border is shown on page load if region is selected
    });

  // Mapping from select/URL region names to GeoJSON region names
  const REGION_NAME_MAP = {
    'skane': 'Skåne',
    'kalmar-lan': 'Kalmar',
    'ostergotland': 'Östergötland',
    'varmland': 'Värmland',
    'vasterbotten': 'Västerbotten',
    'vastmanland': 'Västmanland',
    'gavleborg': 'Gävleborg',
    'lappland': 'Västerbotten',
  };

  function initialize() {
    const mapContainer = document.querySelector('.campsite-page__map');
    if(mapContainer){
      geocoder = new google.maps.Geocoder();
      var myOptions = {
        zoom: DEFAULT_ZOOM,
        center: new google.maps.LatLng(DEFAULT_LAT, DEFAULT_LNG),
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

      // Campsites Marks
      if (typeof campsiteLocations !== 'undefined') {
        campsiteLocations.forEach(function(location) {
          var markerPosition = new google.maps.LatLng(location.lat, location.lng);
          var marker = new google.maps.Marker({
            position: markerPosition,
            map: map,
            title: location.title,
            icon: "data:image/svg+xml;base64,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"
          });

          markers.push(marker);

          var infoWindow = new google.maps.InfoWindow({
            content: `
              <div class="details_mark">
                <p class="details_mark__title">${location.title}</p>
                <a class="details_mark__link btn-default" href="${location.link}">
                  View Details
                </a>
              </div>`
          });

          marker.addListener('click', function() {
            infoWindow.open(map, marker);
          });
        });
      }
    }
  }
  
  function findAddress(address) {
    if (!address) {
      address = document.getElementById("campsite-region").value;
    }
  
    // console.log('Finding address for region:', address);
  
    if (!address) {
      // console.log('No address provided, resetting to default view');
      map.setCenter({ lat: DEFAULT_LAT, lng: DEFAULT_LNG });
      map.setZoom(DEFAULT_ZOOM);
      
      if (regionPolygon) {
        regionPolygon.setMap(null);
        regionPolygon = null;
      }
      
      return;
    }
  
    // Highlight region polygon if GeoJSON loaded
    let foundPolygon = false;
    if (swedenRegionsGeojson) {
      // Remove previous polygon
      if (regionPolygon) {
        regionPolygon.setMap(null);
        regionPolygon = null;
      }
      // Map select/URL name to GeoJSON name if needed
      let geojsonName = REGION_NAME_MAP[address] || address;
      console.log('Looking for region border in GeoJSON for:', geojsonName);
      // Find region by name (case-insensitive)
      const feature = swedenRegionsGeojson.features.find(f => f.properties.name.toLowerCase() === geojsonName.toLowerCase());
      if (feature) {
        // Handle Polygon and MultiPolygon
        let paths = [];
        if (feature.geometry.type === 'Polygon') {
          paths = feature.geometry.coordinates.map(ring => ring.map(([lng, lat]) => ({ lat, lng })));
        } else if (feature.geometry.type === 'MultiPolygon') {
          paths = feature.geometry.coordinates.map(poly => poly[0].map(([lng, lat]) => ({ lat, lng })));
        }
        regionPolygon = new google.maps.Polygon({
          paths: paths,
          strokeColor: '#F5D83E',
          strokeOpacity: 0.9,
          strokeWeight: 2,
          fillColor: '#000000',
          fillOpacity: 0,
          map: map
        });
        // Fit map to polygon bounds
        const bounds = new google.maps.LatLngBounds();
        paths.flat().forEach(coord => bounds.extend(coord));
        map.fitBounds(bounds);
        google.maps.event.addListenerOnce(map, "bounds_changed", function () {
          map.setZoom(map.getZoom() + 1); // Increase zoom by 1 for better view
        });
        foundPolygon = true;
      }
    }

    // Only use geocoder if polygon not found
    if (!foundPolygon && geocoder) {
      geocoder.geocode({ address: address }, function (results, status) {
        // console.log('Geocoding results:', { status, results });
        if (status === google.maps.GeocoderStatus.OK) {
          if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
            if (results[0].geometry && results[0].geometry.viewport) {
              const viewport = results[0].geometry.viewport;
              const ne = viewport.getNorthEast();
              const sw = viewport.getSouthWest();
              const latDiff = Math.abs(ne.lat() - sw.lat());
              const lngDiff = Math.abs(ne.lng() - sw.lng());
              let zoomLevel;
              if (latDiff > 5 || lngDiff > 5) {
                zoomLevel = 8;
              } else if (latDiff > 2 || lngDiff > 2) {
                zoomLevel = 7;
              } else if (latDiff > 1 || lngDiff > 1) {
                zoomLevel = 6;
              } else {
                zoomLevel = 5;
              }
              // console.log('Region size:', { latDiff, lngDiff, zoomLevel });
              map.fitBounds(viewport);
              google.maps.event.addListenerOnce(map, "bounds_changed", function () {
                map.setZoom(zoomLevel);
              });
            }
          } else {
            // console.log('No results found for address:', address);
            alert("No results found");
          }
        } else {
          // console.log('Geocoding failed:', status);
          alert("Geocode was not successful for the following reason: " + status);
        }
      });
    }
  }  

  
  initialize();

  function updateUrlParam(regionSlug) {
    const newUrl = new URL(window.location.href);
  
    if (regionSlug) {
      newUrl.searchParams.set('region', regionSlug);
    } else {
      newUrl.searchParams.delete('region');
    }
    window.history.pushState({}, '', newUrl);
  }

  function getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function regionRedirect(){
    const regionFromUrl = getUrlParam('region');
    // console.log('Region from URL:', regionFromUrl);
    
    if (regionFromUrl) {
      const regionSelect = document.getElementById('campsite-region');
      const searchInput = document.getElementById('campsite-search');
  
      if (regionSelect) {
        // console.log('Setting region select value to:', regionFromUrl);
        regionSelect.value = regionFromUrl;
  
        const niceSelectWrapper = document.querySelector('.nice-select');
        if (niceSelectWrapper) {
          const selectedOptionText = regionSelect.options[regionSelect.selectedIndex].textContent;
          niceSelectWrapper.querySelector('.current').textContent = selectedOptionText;
          const dropdownItems = niceSelectWrapper.querySelectorAll('.list li');
          dropdownItems.forEach(li => li.classList.remove('selected'));
          const selectedDropdownItem = Array.from(dropdownItems).find(li => li.dataset.value === regionFromUrl);
          if (selectedDropdownItem) {
            selectedDropdownItem.classList.add('selected');
          }
        }
  
        filterCampsite(regionFromUrl, searchInput.value);
        findAddress(regionFromUrl);
      }
    }
  }

  function filterCampsite(regionSlug = '', searchValue = '') {
    // console.log('Filtering campsites with region:', regionSlug, 'and search:', searchValue);
    updateUrlParam(regionSlug);
    const ajaxUrl = SiteVars.ajaxUrl;
    const campsiteList = document.querySelector('.campsite-page__list');
    const submitList = document.querySelector('.campsite-page__filter--submit');
    const campsiteTitle = document.querySelector('.campsite-page__list-title');

    campsiteList.classList.add('loading');
    submitList.classList.add('loading--data');

    const data = new FormData();
    data.append('action', 'filter_campsite');
    data.append('campsite-region', regionSlug);
    data.append('campsite-search', searchValue);

    fetch(ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
    .then(response => response.json())
    .then(response => {
      if (response.success) {
        campsiteList.innerHTML = response.data.html;
        campsiteList.classList.remove('campsite-region');
        if (!regionSlug) {
          campsiteTitle.textContent = 'Alla campingplatser';
        } else {
          const regionSelect = document.getElementById('campsite-region');
          const regionName = regionSelect.options[regionSelect.selectedIndex].textContent;
          campsiteTitle.textContent = 'Campingplatser i ' + regionName;
        }
      } else {
        console.error('Error in AJAX response:', response);
      }
      })
      .catch(error => {
        console.error('Error in AJAX request:', error);
      })
      .finally(() => {
        campsiteList.classList.remove('loading');
        submitList.classList.remove('loading--data');
        initCampsiteSliders();
      });
  }

  function initCampsiteFilters() {
    const filterForm = document.getElementById('campsite-filter-form');
    const regionSelect = document.getElementById('campsite-region');
    const searchInput = document.getElementById('campsite-search');
    const itemTaxElements = document.querySelectorAll('.campsite-page__item-tax');

    if (filterForm) {
      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const selectedRegion = regionSelect.value;
        const searchValue = searchInput.value;
        filterCampsite(selectedRegion, searchValue);
        updateUrlParam(selectedRegion);
        findAddress(selectedRegion);
      });
    }


    // Filter on Region Click
    if (itemTaxElements.length > 0) {
      itemTaxElements.forEach(item => {
        item.addEventListener('click', function () {
          const regionSlug = this.getAttribute('data-slug');
          if (regionSlug && regionSelect) {
            // Update region selected value
            regionSelect.value = regionSlug;

            // Update Nice Select
            const niceSelectWrapper = document.querySelector('.nice-select');
            if (niceSelectWrapper) {
              const selectedOptionText = regionSelect.options[regionSelect.selectedIndex].textContent;
              niceSelectWrapper.querySelector('.current').textContent = selectedOptionText;
              const dropdownItems = niceSelectWrapper.querySelectorAll('.list li');
              dropdownItems.forEach(li => li.classList.remove('selected'));
              const selectedDropdownItem = Array.from(dropdownItems).find(li => li.dataset.value === regionSlug);
              if (selectedDropdownItem) {
                selectedDropdownItem.classList.add('selected');
              }
            }

            filterCampsite(regionSlug, searchInput.value);
            updateUrlParam(regionSlug);
            findAddress(regionSlug);
          }
        });
      });
    }
  }

  initCampsiteFilters();

  function initCampsiteSliders() {
    const swiperContainers = document.querySelectorAll('.campsite-item .swiper-container');
    
    if (swiperContainers.length === 0) {
      return;
    }
  
    swiperContainers.forEach((container, index) => {
      const slides = container.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) {
        return;
      }
  
      new Swiper(container, {
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }
  
  initCampsiteSliders();
});
